import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SuggestComboBox,
  SuggestComboBoxProps,
} from '../../../../components/molecules/Form/components/ComboBox/AbstractComboBox/SuggestComboBox';
import { TopUserResult } from '../../../../components/molecules/Form/components/ComboBox';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';

// eslint-disable-next-line max-len
import { FormsComboboxMultiSelectList } from '../../../../components/molecules/Form/components/FormsComboboxMultiSelect/partials/FormsComboboxMultiSelectList';
import { AddUserMultiSelectListItem } from './AddUserMultiSelectListItem';

import ListItemPerson
  from '../../../../components/molecules/Form/components/ComboBox/AbstractComboBox/ListItemPerson/ListItemPerson';
import { AddUserRoleParam } from './AddUser';
import getUserTopResults from '../../../../components/molecules/Form/components/ComboBox/User/getUserTopResults';

type AddUserSelectComboBoxType = {
  rolesParam: AddUserRoleParam<'roles'>;
};

export function AddUserSelectComboBox({
  rolesParam,
  ...props
}: AddUserSelectComboBoxType & Omit<SuggestComboBoxProps<TopUserResult>, 'id' | 'onSelection' | 'validationMessage'>) {
  const { t } = useTranslation('Members');
  const [selectedResults, setSelectedResults] = useState<TopUserResult[]>([]);

  const id = useHtmlValidId();
  const headerLabelId = useHtmlValidId();

  const removeResult = (item: TopUserResult) => {
    setSelectedResults(prevState => prevState.filter(result => result.id !== item.id));
  };

  const addResult = (item?: TopUserResult) => {
    if (item && !selectedResults.some(result => result.id === item.id)) {
      setSelectedResults(prevState => [...prevState, item]);
    }
  };

  return (
    <>
      <SuggestComboBox
        {...props}
        name={undefined}
        id={`add-user-select-combobox-${id}`}
        responseMapper={getUserTopResults}
        onSelection={(item) => {
          addResult(item as TopUserResult);
        }}
        validationMessage={
          props.required && !selectedResults.length ? t('FormsComboBox:content.validationMessage') : undefined
        }
      >
        {item => <ListItemPerson user={item} />}
      </SuggestComboBox>
      {selectedResults && selectedResults.length > 0 && (
        <>
          <h3 className="invisible" id={headerLabelId}>
            {t('selectedPersons')}
          </h3>
          <FormsComboboxMultiSelectList labelId={headerLabelId} modifier="margin-top">
            {selectedResults.map((selectedResult, userId) => (
              <AddUserMultiSelectListItem
                key={selectedResult.id}
                selectedResult={selectedResult}
                removeResult={removeResult}
                rolesParam={rolesParam}
                userId={userId}
              />
            ))}
          </FormsComboboxMultiSelectList>
        </>
      )}
    </>
  );
}
